module.exports = __webpack_public_path__ + "static/img/058.f8336b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/058.png
// module id = SV7G
// module chunks = 0